// External Imports
import { createSelector } from 'reselect';

// Internal Imports
import { getContentArchiveBase } from './getContentArchiveBase.mjs';

// Local Functions
const getArchivedPagination = createSelector(
  [getContentArchiveBase],
  ({ pagination } = {}) => pagination,
);

// Module Exports
export { getArchivedPagination };
